import React from 'react'
import { PublicMeeting } from '@chilipiper/api-client/src/meetings'
import { IconSuccess } from '@chilipiper/icons/figma-generated/src/icon'
import { Box, Divider, Flex, Icon, Spinner, Text } from '@chilipiper/design-system'
import { LinkButton } from '@chilipiper/design-system/src/new'
import { useTranslations } from '../../../context/TranslationContext'
import { DisplayDate } from './DisplayDate'

type Props = {
  email: string | undefined
  meeting?: PublicMeeting
  onClick: () => void
  timezone: string
}

export const BookingConfirmation = ({ email, meeting, onClick, timezone }: Props) => {
  const [
    youWillReceiveMeetingInvitationShortly,
    time,
    guests,
    rescheduleButton,
    loadingMeetingDetails,
  ] = useTranslations([
    'youWillReceiveMeetingInvitationShortly',
    'time',
    'guests',
    'rescheduleButton',
    'loadingMeetingDetails',
  ])
  if (!meeting) {
    return (
      <Flex justifyContent='center' alignItems='center' h='132px'>
        <Spinner mr={2} />
        <Text color='fg/moderate' textStyle='body-multiline'>
          {loadingMeetingDetails ?? 'Loading meeting details'}
        </Text>
      </Flex>
    )
  }
  return (
    <Box px={3} pt={2}>
      <Flex
        gap={3}
        px={6}
        py={3}
        bg='bg/section-emphasis'
        boxShadow='border/on-major'
        borderRadius={12}
      >
        <Icon mt={1} flexShrink={0} icon={IconSuccess} color='fg/success' />
        <Text color='fg/major' textStyle='body-multiline'>
          {youWillReceiveMeetingInvitationShortly}
        </Text>
      </Flex>
      <Flex pt={4} pb={5} px={2}>
        <Box w={12} flexShrink={0}>
          <Text textStyle='body-monoline' color='fg/moderate'>
            {time}
          </Text>
        </Box>
        <Box>
          <Text color='fg/major' textStyle='body-multiline-tight'>
            <DisplayDate timezone={timezone} date={meeting.dateTime} />
          </Text>
          <LinkButton mt={3} variant='minor' onClick={onClick}>
            {rescheduleButton ?? 'Reschedule'}
          </LinkButton>
        </Box>
      </Flex>
      <Divider mx={2} />
      <Flex pt={4} pb={5} px={2}>
        <Box w={12} flexShrink={0}>
          <Text textStyle='body-monoline' color='fg/moderate'>
            {guests || 'Guests'}
          </Text>
        </Box>
        <Text textStyle='body-multiline-tight' color='fg/major' wordBreak='break-all'>
          {email ?? 'You'}
        </Text>
      </Flex>
    </Box>
  )
}
